import { render, staticRenderFns } from "./visit.page.vue?vue&type=template&id=66034315&scoped=true"
import script from "./visit.page.vue?vue&type=script&lang=js"
export * from "./visit.page.vue?vue&type=script&lang=js"
import style0 from "./visit.page.vue?vue&type=style&index=0&id=66034315&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66034315",
  null
  
)

export default component.exports